import React, {createRef, useEffect} from 'react'
import styles from './FJApplyLoading.module.less'
import $ from 'jquery'

function FJApplyLoading() {

  const ani = createRef();
  const checkIcon = createRef();

  useEffect(() => {
    $(ani.current).css({opacity: 1});
    $(ani.current).addClass(styles.icon_animation);
    setTimeout(() => {
      $(ani.current).removeClass(styles.icon_animation);
      $(checkIcon.current).css({opacity: 1});
      setTimeout(() => {
        $(ani.current).css({opacity: 0});
        $(checkIcon.current).css({opacity: 0});
      }, 1000);
    }, 1100);
  }, [])

  return (
    <div className={styles.box}>
      <svg className={styles.icon1} ref={ani} width="32px" height="32px"
           viewBox="0 0 32 32">
        <circle fill="none" stroke="#FF822C" strokeWidth="2" cx="16" cy="16" r="15" />
      </svg>
      <svg className={styles.icon2} ref={checkIcon} xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="18px"
           height="18px">
        <path fill="#FF822C" d="M7.826,14.348l8.763-8.724C16.852,5.366,17,5.009,17,4.642c0-0.372-0.146-0.72-0.41-0.982
	c-0.521-0.522-1.457-0.521-1.979,0l-7.66,7.625l-2.92-3.628C3.786,7.286,3.355,7.068,2.895,7.068c-0.056,0-0.112,0.003-0.168,0.01
	c-0.525,0.063-0.964,0.41-1.144,0.905S1.517,9.021,1.879,9.405l3.872,4.819c0.243,0.309,0.607,0.498,1.001,0.524l0.091,0.001
	l0.002,0.249l0,0V14.75C7.21,14.75,7.567,14.604,7.826,14.348z"/>
      </svg>
    </div>
  );
}

export default FJApplyLoading;